import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, vModelText as _vModelText, withModifiers as _withModifiers, withKeys as _withKeys, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9caefeca"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-box" }
const _hoisted_2 = { class: "relative tags-list" }
const _hoisted_3 = { class: "flex items-center space-x-2" }
const _hoisted_4 = { class: "text-sm" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.5",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true",
  class: "w-4 h-4 text-gray-800"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    d: "M6 18L18 6M6 6l12 12"
  })
], -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { key: 0 }
const _hoisted_9 = ["placeholder"]
const _hoisted_10 = { key: 1 }
const _hoisted_11 = ["placeholder"]
const _hoisted_12 = {
  key: 0,
  class: "absolute z-20 w-64 overflow-y-auto border border-gray-400 rounded shadow h-80 bg-play-gray bottom-10"
}
const _hoisted_13 = { class: "flex items-center justify-between border-b border-gray-400" }
const _hoisted_14 = { class: "w-full px-4 py-2 text-left" }
const _hoisted_15 = {
  class: "font-medium text-gray-900 capitalize",
  id: "modal-title"
}
const _hoisted_16 = { class: "py-4 pl-2 pr-4" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "bi bi-x-lg",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z" })
], -1))
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = ["onClick"]

import { ref, computed, PropType, onMounted } from "vue";
import { clickOutSide as vClickOutSide } from "@mahdikhashan/vue3-click-outside";

import api from "@/api/api";
import { useGlobalStore } from "@/store";
import { Tag } from "@/types";
import { useI18n } from "vue-i18n";


export default /*#__PURE__*/_defineComponent({
  __name: 'TagSelector',
  props: {
  tags: {
    type: Array as PropType<Tag[]>,
    required: false,
  },
  type: {
    type: String as PropType<string>,
    required: true,
  },
  multiple: {
    type: Boolean as PropType<boolean>,
    required: false,
    default: false,
  },
},
  emits: ["change"],
  async setup(__props, { emit: emits }) {

let __temp: any, __restore: any

const props = __props;

const { t: $t } = useI18n();

const globalStore = useGlobalStore();



const tags = ref([] as Tag[]);
const isMenuOpen = ref(false);
const selectedTags = ref([] as Tag[]);
const text = ref("");

const filteredOptions = computed(() => {
  return tags.value.filter((i: Tag) => i.name.includes(text.value) && !selectedTags.value.find(tag => i === tag));
});

function clickOutside() {
  if (isMenuOpen.value) {
    return (isMenuOpen.value = false);
  }
}

function remove(index: number) {
  selectedTags.value.splice(index, 1);
  emits(
    "change",
    selectedTags.value.map(i => {
      return i.id;
    })
  );
}

function add(tag: Tag) {
  // If tag is already selected, reset the text box
  if (selectedTags.value.find(t => t.name.toLowerCase() == tag.name.toLowerCase())) {
    text.value = "";
    return;
  }

  selectedTags.value.push(tag);

  isMenuOpen.value = false;
  text.value = "";
  emits(
    "change",
    selectedTags.value
      .filter(i => i !== undefined)
      .map(i => {
        return i.id;
      })
  );
}

async function create(newTag: string) {
  try {
    // If tag is already selected, reset the text box
    if (selectedTags.value.length > 0 && selectedTags.value.find(tag => tag.name.toLowerCase() === newTag.toLowerCase())) {
      text.value = "";
      return;
    }

    if (!newTag) return globalStore.toast("ERROR", $t("tag-name-required"));

    const response = await api.tags.createTag({ name: newTag, type: props.type });

    if (response.meta.status === 400) {
      throw new Error("Error creating tag");
    }

    tags.value.push(response.data.tag);
    add(response.data.tag);

    text.value = "";
    globalStore.toast("SUCCESS", $t("tag-created"));
  } catch (e) {
    console.log(e);
    globalStore.toast("ERROR", $t("error-creating-tag"));
  }
}

tags.value = ((
  ([__temp,__restore] = _withAsyncContext(() => api.tags.listTags(props.type))),
  __temp = await __temp,
  __restore(),
  __temp
)).data.tags;

onMounted(() => {
  if (props.tags) {
    selectedTags.value = props.tags ?? [];
  }
});

return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedTags.value, (item, index) => {
        return (_openBlock(), _createElementBlock("span", {
          class: "bg-gray-200 border border-gray-500 tags-list-item",
          key: index
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("span", _hoisted_4, _toDisplayString(item.name), 1),
            _createElementVNode("button", {
              class: "items-center rounded-full",
              onClick: ($event: any) => (remove(index)),
              type: "button"
            }, _hoisted_7, 8, _hoisted_5)
          ])
        ]))
      }), 128)),
      _createElementVNode("div", null, [
        (__props.multiple)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "w-64 tags-input",
                placeholder: _unref($t)('enter-new-tags'),
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((text).value = $event)),
                onFocus: _cache[1] || (_cache[1] = ($event: any) => (isMenuOpen.value = true)),
                onKeypress: _cache[2] || (_cache[2] = _withKeys(_withModifiers(($event: any) => (create(text.value)), ["prevent"]), ["enter"]))
              }, null, 40, _hoisted_9), [
                [_vModelText, text.value]
              ])
            ]))
          : _createCommentVNode("", true),
        (!__props.multiple && selectedTags.value.length < 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "w-64 tags-input",
                placeholder: _unref($t)('enter-new-tags'),
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((text).value = $event)),
                onFocus: _cache[4] || (_cache[4] = ($event: any) => (isMenuOpen.value = true)),
                onKeypress: _cache[5] || (_cache[5] = _withKeys(_withModifiers(($event: any) => (create(text.value)), ["prevent"]), ["enter"]))
              }, null, 40, _hoisted_11), [
                [_vModelText, text.value]
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      (isMenuOpen.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("h3", _hoisted_15, _toDisplayString(_unref($t)("tags")), 1)
              ]),
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("button", {
                  onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (isMenuOpen.value = false), ["self"])),
                  type: "submit"
                }, _hoisted_18)
              ])
            ]),
            _createElementVNode("ul", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(filteredOptions), (item) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: item.id,
                  class: "flex items-center justify-between w-full px-4 py-3 border-b hover:cursor-pointer hover:text-white hover:bg-primary",
                  onClick: ($event: any) => (add(item))
                }, [
                  _createElementVNode("span", null, _toDisplayString(item.name), 1)
                ], 8, _hoisted_19))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ])), [
    [_unref(vClickOutSide), clickOutside]
  ])
}
}

})